import { useMatches } from "@tanstack/react-router";

export const useRoute = () => {
    const matches = useMatches();
    const getCurrentRoute = () => {
        return matches[matches.length - 1];
    };

    return {
        getCurrentRoute,
    };
};
